import React, { useEffect, useState } from "react";
import { Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import { NotificationActions } from "../../../../slices/NotificationSlice";
import { GetAllNotification_M3 } from "../../../../api/notifyapi/Notifyapi";
import filterIcon from "../../assets/filter-2.svg";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import { ESearchFilterActiveTypes } from "../../../../constants/CommonInterfaces";
import { DBTilte } from "./ExtensiveFilterContent";
import FilterContent from "./FilterContent";

export interface IFilterObjects {
  id: string;
  title: string;
  createdBy: { name: string; date: any };
  updatedBy: { name: string; date: any };
  status: string;
  category: string;
}
interface ColumnFilterProps {
  searchField?: string;
  accessorKey: string;
  isFilter?: boolean;
}

const FilterPopup: React.FC<ColumnFilterProps> = ({
  searchField,
  accessorKey,
  isFilter,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const { apiQuery } = useSelector(
    (state: RootState) => state.notification.searchFilter
  );

  const searchQueryLocal = useSelector(
    (state: RootState) => state.notification.searchFilter.columnSearch
  );

  // Popover visibility state
  const [isPopoverVisible, setIsPopoverVisible] = useState<boolean>(false);
  const [isToggleCategory, setIstoggleCategory] = useState<boolean>(false);
  const [isToggleStatus, setIstoggleStatus] = useState<boolean>(false);
  const [isEnableSearch, setIsEnableSearch] = useState<boolean>(false);

  const handleToggle = (field: string): void => {
    if (field === "category") {
      setIstoggleCategory(!isToggleCategory);
    } else if (field === "status") {
      setIstoggleStatus(!isToggleStatus);
    }
  };

  // Common handler for opening filter popover
  const handleFilterClick = () => {
    setIsPopoverVisible(!isPopoverVisible);
  };

  // Common handler for closing filter popover
  const handleFilterClose = () => {
    setIsPopoverVisible(false);
  };

  // Generic input change handler for base filter
  const handleFilterInputChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
    field: string,
    operator: string,
    localField: string
  ) => {
    setIsEnableSearch(false);
    dispatch(
      NotificationActions.UpdateLocalSearchQuery({
        field: localField,
        value: event.target.value,
      })
    );
  };

  // handle changes for category and status
  const handleDropDownChanges = (item: string, field: string): void => {
    setIsEnableSearch(false);
    if (field === "category") {
      dispatch(
        NotificationActions.UpdateLocalSearchQuery({
          field: "category",
          value: item,
        })
      );
      setIstoggleCategory(false);
    } else if (field === "status") {
      dispatch(
        NotificationActions.UpdateLocalSearchQuery({
          field: "status",
          value: item,
        })
      );
      setIstoggleStatus(false);
    }
  };

  // handle dateRange picker
  const handleDateRangeChange = (
    field: string,
    dates: any,
    localField: string
  ) => {
    setIsEnableSearch(false);
    const startDate = dates[0];
    const endDate = dates[1];
    let localSearchDate = "";

    if (startDate !== "" && endDate !== "") {
      localSearchDate = dates;
    }

    if (dates.length !== 0) {
      dispatch(
        NotificationActions.UpdateLocalSearchQuery({
          field: localField,
          value: localSearchDate,
        })
      );
    }
  };

  // useEffect fucntion for search value sent to the after setting hte value
  useEffect(() => {
    if (isEnableSearch) {
      let lSearchQuery = Object.assign({}, apiQuery);

      lSearchQuery.filters = lSearchQuery.filters.filter((x) => {
        // Handle different types of values
        if (typeof x.value === "string") {
          // For strings, check if it's not an empty string after trimming
          return x.value.trim() !== "";
        }

        // For other types (numbers, etc.), check if the value is not null or undefined
        return x.value !== null && x.value !== undefined;
      });
      console.log("lSearchQuery: ", lSearchQuery);
      lSearchQuery.isOr = false;
      lSearchQuery.page = 1;

      dispatch(
        NotificationActions.UpdatePagination({
          page: 1,
          pageSize: apiQuery.pageSize,
          isPageChanged: false,
        })
      );

      dispatch(
        NotificationActions.UpdateGlobalSearchFilter({
          value: "",
        })
      );
      dispatch(NotificationActions.UpdateGlobalSearchFilterActive());
      dispatch(
        NotificationActions.UpdateLastActiveSearch({
          value: ESearchFilterActiveTypes.column,
        })
      );

      dispatch(GetAllNotification_M3(lSearchQuery));
      setIsEnableSearch(false);
      handleFilterClose();
    }
  }, [isEnableSearch]);

  // Apply filter based on accessor key
  const handleApplyFilter = async () => {
    // Apply temp search values to actual search query
    dispatch(NotificationActions.ApplyColumnSearchFilter());
    setIsEnableSearch(true);
  };

  const handleToClear = (field: string, field2?: string): void => {
    setIsEnableSearch(false);
    dispatch(
      NotificationActions.ResetColumnSearchFilter({
        canClearAll: false,
        fieldClear: field,
        field2: field2,
      })
    );
    let lSearchQuery = Object.assign({}, apiQuery);
    if (field2) {
      lSearchQuery.filters = lSearchQuery.filters.filter(
        (x) => x.field !== DBTilte[field2 as keyof typeof DBTilte]
      );
    }
    lSearchQuery.filters = lSearchQuery.filters.filter(
      (x) => x.field !== DBTilte[field as keyof typeof DBTilte]
    );
    lSearchQuery.page = 1;
    dispatch(
      NotificationActions.resetLocalSearchQuery({
        canClearAll: false,
        fieldClear: field,
        field2: field2,
      })
    );
    dispatch(
      NotificationActions.UpdateGlobalSearchFilter({
        value: "",
      })
    );
    dispatch(NotificationActions.UpdateGlobalSearchFilterActive());
    dispatch(GetAllNotification_M3(lSearchQuery));
    handleFilterClose();
  };

  // Render filter icon based on accessor key
  const renderFilterIcon = () => {
    switch (accessorKey) {
      case "ExtensiveSearch":
        return (
          <button className="filter-button">
            <img src={filterIcon} alt="filter" />
            Filter
          </button>
        );
      default:
        return (
          <button
            className="column-filter-button"
            onClick={() => handleFilterClick()}
          >
            <FilterAltIcon
              className="column-filter-icon"
              style={{
                backgroundColor: isFilter ? "#fff" : "",
                color: isFilter ? "#ec6c2a" : "",
              }}
            />
          </button>
        );
    }
  };

  return (
    <Popover
      content={
        // <div className="column-filter-container">{renderFilterContent()}</div>
        <FilterContent
          accessorKey={accessorKey}
          searchField={searchField}
          searchQueryLocal={searchQueryLocal}
          isToggleCategory={isToggleCategory}
          isToggleStatus={isToggleStatus}
          handleFilterInputChange={handleFilterInputChange}
          handleDateRangeChange={handleDateRangeChange}
          handleToggle={handleToggle}
          handleDropDownChanges={handleDropDownChanges}
          handleToClear={handleToClear}
          handleApplyFilter={handleApplyFilter}
          handleFilterClose={handleFilterClose}
        />
      }
      trigger="click"
      open={isPopoverVisible}
      onOpenChange={(visible) => setIsPopoverVisible(visible)}
      placement={accessorKey === "ExtensiveSearch" ? "bottomRight" : "bottom"}
    >
      {renderFilterIcon()}
    </Popover>
  );
};

export default FilterPopup;
